import React, { useState } from "react";
import CommonFrom from "../../../Common/Components/Form";
import { Formsumbit } from "./Components/Services";

function Create({ isApp, reloadPage, setReloadPage }) {
  const initalState = {
    loading: false,
  };
  const [state, setstate] = useState(initalState);

  const Handler = data => {
    setstate({ loading: true });
    Formsumbit(data).then(() => {
      setstate({
        loading: false,
      });
      if (isApp) {
        setReloadPage(reloadPage + 1)
      }
    });
  };

  return (
    <CommonFrom
      shadowClass={isApp && "shadow-none mt-3 appInputBox"}
      classChildBox={isApp && "px-0"}
      form={input}
      loading={state.loading}
      header={!isApp && " درخواست به پشتیبانی "}
      textbtn="لیست درخواست ها "
      linkbtn="/User/ticketing/List"
      btnName="ثبت درخواست"
      submit={Handler}
      isApp={isApp}
    />
  );
}

export default Create;
export const input = [
  {
    label: "عنوان سوال",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "عنوان سوال خود را وارد کنید ...",
    name: "title",
    value: "",
  },
  {
    label: "نوع سوال",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "departman",
    input: "select",
    options: [
      { id: "technical", name: "فنی" },
      { id: "financial", name: "مالی" },
      { id: "complaints", name: "شکایات" },
      { id: "reservation", name: "رزرو" },
    ],
  },
  {
    label: "سوال",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "سوال خود را وارد کنید ...",
    name: "description",
    input: "textarea",
  },
];
